import networksConfig from '../config/networks.json'

export const SITES_BY_NETWORK = networksConfig.SITES_BY_NETWORK
